import { GenericCollectionFactory } from "../../Common/_generics/GenericCollectionFactory";

export const PMSLocationGroupsCollection = GenericCollectionFactory("PMS_LOCATION_GROUPS", "uid")